import React from 'react';
import { Button, Tooltip } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { CreditCardTwoTone } from '@ant-design/icons';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';

export type CCardButtonProps = Omit<ButtonProps, 'icon'> & {
  comcode: string;
  twoToneColor: string;
};

const CCardButton = ({
  comcode,
  twoToneColor,
  ...otherProps
}: CCardButtonProps) => {
  const { label, hint } = useComponentConfiguration(comcode);
  return (
    <Tooltip title={hint}>
      <Button
        icon={<CreditCardTwoTone twoToneColor={twoToneColor} />}
        {...otherProps}
      >
        {label}
      </Button>
    </Tooltip>
  );
};

export default CCardButton;
